export class Bus {
  public id: string;
  public number: string;
  public registrationNumber: number;
  public busType: string;
  public fuel: string;
  public active: boolean;
  public onService: boolean;
  public serviceDescription: string;
}
